import type { CommunityGroup } from '@communities/community-groups/domain';
import { BaseItem, Heading, Text } from '@soteria/design-system-ve';

import * as styles from './CommunityGroupItem.css.ts';

interface CommunityGroupItemProps {
  communityGroup: CommunityGroup;
  onClick: (communityGroup: CommunityGroup) => void;
}

/**
 * Interactive item component for displaying a community group
 * Uses BaseItem for better accessibility and semantic HTML
 */
export function CommunityGroupItem({ communityGroup, onClick }: CommunityGroupItemProps) {
  return (
    <BaseItem as="button" background="visible" className={styles.itemContainer} type="button" onPress={() => onClick(communityGroup)}>
      <div className={styles.contentWrapper}>
        <Heading level="h2" size="xl" weight="semibold">
          {communityGroup.name}
        </Heading>

        <Text className={styles.description} color="secondary" size="sm">
          {communityGroup.description || 'No description available'}
        </Text>
      </div>
    </BaseItem>
  );
}
